import api from 'api';

export const loadPartnerCompanyGrid = api('POST /api/partner-companies/grid');

export const loadPartnerCompanyDetails = api(
  'GET /api/partner-companies/:id/details'
);

export const loadPartnerCompany = api('GET /api/partner-companies/:id');

export const createPartnerCompany = api('POST /api/partner-companies');

export const updatePartnerCompany = api('PUT /api/partner-companies/:id');

export const archivePartnerCompany = api(
  'POST /api/partner-companies/:id/archive'
);

export const restorePartnerCompany = api(
  'POST /api/partner-companies/:id/restore'
);

export const deletePartnerCompany = api(
  'POST /api/partner-companies/:id/delete'
);
